export const formValues = {
  AndroidVersion: '0.0.0',
  AndroidURL: '',
  IOSVersion: '0.0.0',
  IOSURL: '',
  MacOsVersion: '0.0.0',
  MacOsURL: '',
  WindowsVersion: '0.0.0',
  WindowsURL: ''
}